import React from 'react';
import styles from './onboardingHero.module.css';

interface HeroBackgroundImageProps {
  src: string;
  alt: string;
  objectPosition?: string;
  topCropPx?: number;
}

const HeroBackgroundImage: React.FC<HeroBackgroundImageProps> = ({
  src,
  alt,
  objectPosition = 'center',
  topCropPx,
}) => (
  <img
    className={`${styles.backgroundImage}${topCropPx ? ` ${styles.backgroundImageTopCrop}` : ''}`}
    src={src}
    alt={alt}
    style={{
      objectPosition,
      ...(topCropPx
        ? { '--hero-image-top-crop': `${topCropPx}px` } as React.CSSProperties
        : {}),
    }}
  />
);

export default HeroBackgroundImage;
